// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { purple, white } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const VirtualVisitIconSVG = styled(Icon).attrs({ viewBox: '0 0 30 30' })`
    font-size: 30px;
`;

function VirtualVisitIcon({
    backgroundColor = purple,
    color = white,
    strokeColor = purple,
    skipCircle = false,
    ...props
}) {
    return (
        <VirtualVisitIconSVG data-test="virtual-visit-icon" {...props}>
            {!skipCircle && (
                <circle
                    cx="15"
                    cy="15"
                    r="14"
                    fill={backgroundColor}
                    stroke={strokeColor}
                    strokeWidth="2"
                />
            )}
            <path
                d="M18.826 13.187v2.723L23 17.652v-6.26l-4.174 1.795zm0-3.187H7v9.044h11.826V10z"
                stroke={skipCircle ? backgroundColor : color}
                strokeWidth="2"
                strokeMiterlimit="10"
                fill={backgroundColor}
            />
        </VirtualVisitIconSVG>
    );
}

export { VirtualVisitIcon as default, VirtualVisitIcon };
